import { render, staticRenderFns } from "./QuizTree.vue?vue&type=template&id=6fd984ce&"
import script from "./QuizTree.vue?vue&type=script&lang=js&"
export * from "./QuizTree.vue?vue&type=script&lang=js&"
import style0 from "./QuizTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports